import uniq from "lodash/uniq"
import { AppLoader, Tags } from "@/components/utils"
import { useAPIResources } from "@/hooks"
import type { TTag } from "@/types"
import { tagsAPI } from "@/utils"
import { getChoicesByBinaryMask } from "../../questions/utils"
import type { IMultiAnswerProps } from "./types"
import { filterAnswersWithValue } from "./utils"

export function MultiAnswerTags({ question, answers }: IMultiAnswerProps) {
  const {
    meta: { category },
  } = question
  const answersDone = filterAnswersWithValue(answers)
  const { data: { data: tags = [] } = {}, isLoading } = useAPIResources(tagsAPI, {
    where: { category },
    enabled: !!answersDone.length,
  })
  if (isLoading) return <AppLoader />

  const selectedTags = uniq(
    answersDone.flatMap((a) => getChoicesByBinaryMask(a.value).map((idx) => tags[idx])).filter((t): t is TTag => !!t),
  )

  return <Tags tags={selectedTags.map((tag) => tag.id)} />
}
